import React, { FC } from "react";
import Sidebar from "../../Sidebar";
import ParticipantsInfo, {
  ParticipantsInfoVariantT,
} from "../../../ParticipantsInfo/ParticipantsInfo";
import SidebarProfile from "../SidebarProfile/SidebarProfile";
import { useNonDesktopViewport } from "../../../../utils/hooks/useNonDesktopViewport";
import { BroadcasterT, RecepientT } from "../../../../models/models";

import styles from "./sidebarParticipants.module.scss";

type SidebarParticipantsPropTypes = {
  participants: RecepientT[];
  broadcasters: BroadcasterT[];
  productionCompanyData: {
    name: string;
    id: number;
  };
  mediaCompanyData?: {
    name: string | null;
    id: number | null;
  };
  // spec-41 — both default to today's behaviour, so every existing caller is unchanged (R6).
  // `variant` is forwarded to ParticipantsInfo (D4); `showProfile` puts the logged-in user's
  // profile block on top, the way DeliverySidebar does, so a delivery-service customer does not
  // lose that chrome on the one page where this panel replaces the 1/2/3 steps.
  variant?: ParticipantsInfoVariantT;
  showProfile?: boolean;
};

const SidebarParticipants: FC<SidebarParticipantsPropTypes> = ({
  participants,
  broadcasters,
  productionCompanyData,
  mediaCompanyData,
  variant = "default",
  showProfile = false,
}) => {
  const isNonDesktop = useNonDesktopViewport();

  return !isNonDesktop ? (
    // The sidebarWrapper class is what the PageWrapper grid matches to place this panel in the
    // "side" column (and keep <main> out of it). Without it the sidebar and main overlap.
    <div className={styles.sidebarWrapper}>
      <Sidebar>
        {showProfile && <SidebarProfile />}
        <ParticipantsInfo
          participants={participants}
          broadcasters={broadcasters}
          productionCompanyData={productionCompanyData}
          mediaCompanyData={mediaCompanyData}
          variant={variant}
        />
      </Sidebar>
    </div>
  ) : null;
};

export default SidebarParticipants;
